import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Title = styled.div`
    //font-family: AvenirNextWorld Demi;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Demi'};
    color: ${(props) => (props.color ? props.color : '#202124')};
    width: ${(props) => (props.width ? props.width : '')};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    padding-bottom: ${(props) => (props.paddingBtm ? props.paddingBtm : '0px')};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '0px')};
    padding-right: ${(props) =>
        props.paddingRight ? props.paddingRight : '0px'};
    padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : '0px')};
    .asterisk {
        color: red;
        padding-left: 3px;
    }
    ${media.mobileDevice`
    width: ${(props) => (props.mbWidth ? props.mbWidth : '')};
    padding-bottom: ${(props) =>
        props.mbpaddingBtm ? props.mbpaddingBtm : '0px'};
    padding-top: ${(props) =>
        props.mbpaddingTop ? props.mbpaddingTop : '0px'};
         padding-right: ${(props) =>
             props.mbpaddingRight ? props.mbpaddingRight : '0px'};
    padding-left: ${(props) =>
        props.mbpaddingLeft ? props.mbpaddingLeft : '0px'};
    `};
`;

export const StyledText = styled.div`
    font-size: 16px;
    letter-spacing: 0px;
    color: #140f4b;
    opacity: 1;
    font-family: AvenirNextWorld Regular;
`;

export const AlertText = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    letter-spacing: -0.1px;
    color: ${(props) => (props.color ? props.color : '#ED002A')};
    opacity: 1;
    padding: ${(props) => props.padding};
    ${media.mediumDevice`
         width: ${(props) => props.width};
    `}
    ${media.smalDevice`
         width: ${(props) => props.width};
    `}
     ${media.mobileDevice`
        width: 100%
     `}
`;
